import React from "react";
import "./index.css";

export const CORES = ["#1466c3", "#48a9f8", "#7d8287", "#002c5f", "#f28e2b", "#59a14f", "#e15759", "#76b7b2"];

export const numero = (v) => Number(v || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 });

export const pontos = (v) =>
  Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const percentual = (v) => pontos(v) + "%";

const SemDados = () => <div className="grafico-vazio">Sem dados</div>;

// dados: [{ label, value, color }]
export function Rosca({ titulo, dados }) {
  const total = dados.reduce((s, d) => s + d.value, 0);
  let acumulado = 0;
  const descricao = `${titulo}: ${dados.map((d) => `${d.label} ${numero(d.value)} (${percentual((d.value / total) * 100)})`).join(", ")}`;

  return (
    <div className="grafico-card">
      <div className="grafico-titulo">{titulo}</div>
      {total === 0 ? (
        <SemDados />
      ) : (
        <>
          <svg viewBox="0 0 42 42" className="grafico-rosca" role="img" aria-label={descricao}>
            {dados.map((d) => {
              const pct = (d.value / total) * 100;
              const offset = 25 - acumulado;
              acumulado += pct;
              return (
                <circle key={d.label} cx="21" cy="21" r="15.915" fill="none" stroke={d.color} strokeWidth="6"
                  strokeDasharray={`${pct} ${100 - pct}`} strokeDashoffset={offset}>
                  <title>{`${d.label}: ${numero(d.value)} (${percentual(pct)})`}</title>
                </circle>
              );
            })}
          </svg>
          <div className="grafico-legenda">
            {dados.map((d) => (
              <span key={d.label}>
                <i style={{ background: d.color }} />
                {d.label}: <b>{numero(d.value)}</b> ({percentual((d.value / total) * 100)})
              </span>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

// dados: [{ label, valores: [n por série] }]; séries empilhadas (só na vertical)
// etiqueta: valor em tag azul-marinho (gráfico de Pontuação); com muitas barras o valor fica na vertical
// espacado: barras horizontais mais grossas, para poucas linhas (Motivos de contato)
export function Barras({ titulo, dados, series = [{ nome: "", cor: CORES[0] }], horizontal = false, formato = numero, etiqueta = false, espacado = false }) {
  const totais = dados.map((d) => d.valores.reduce((s, v) => s + v, 0));
  const max = Math.max(0, ...totais);

  let corpo;
  if (max === 0) {
    corpo = <SemDados />;
  } else if (horizontal) {
    corpo = (
      <div className={`barras-h ${espacado ? "barras-h-espacado" : ""}`}>
        {dados.map((d, i) => (
          <div className="barras-h-linha" key={i} title={`${d.label}: ${formato(totais[i])}`}>
            <span className="barras-h-label">{d.label}</span>
            <div className="barras-h-trilho">
              <div style={{ width: `${(totais[i] / max) * 100}%`, background: series[0].cor }} />
              <span>{formato(totais[i])}</span>
            </div>
          </div>
        ))}
      </div>
    );
  } else {
    corpo = (
      <div className={`barras-v ${dados.length > 12 ? "barras-v-denso" : ""}`}>
        {dados.map((d, i) => (
          <div className="barras-v-coluna" key={i}>
            <div className="barras-v-trilho">
              <div className="barras-v-pilha" style={{ height: `${(totais[i] / max) * 100}%` }}>
                {totais[i] > 0 && (
                  <span className={`barras-v-valor ${formato(totais[i]).length <= 2 ? "barras-v-valor-curto" : ""}`}>
                    {formato(totais[i])}
                  </span>
                )}
                {d.valores.map((v, j) =>
                  v > 0 ? (
                    <div key={j} title={`${d.label}${series[j].nome ? " - " + series[j].nome : ""}: ${formato(v)}`}
                      style={{ flex: `${v} 0 0`, background: series[j].cor }} />
                  ) : null
                )}
              </div>
            </div>
            <span className="barras-v-label">{d.label}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`grafico-card ${etiqueta ? "barras-etiqueta" : ""}`}>
      <div className="grafico-titulo">{titulo}</div>
      {corpo}
      {series.length > 1 && max > 0 && (
        <div className="grafico-legenda">
          {series.map((s) => (
            <span key={s.nome}>
              <i style={{ background: s.cor }} />
              {s.nome}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
